var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_6609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3833 13.296C10.0458 11.6627 7 7.6085 7 5.3335C7 2.57225 9.2375 0.333496 12 0.333496C14.7625 0.333496 17 2.57225 17 5.3335C17 7.6085 13.9542 11.6627 12.6167 13.296C12.2958 13.7335 11.7042 13.7335 11.3833 13.296ZM12 6.66683C12.9208 6.66683 13.6667 5.921 13.6667 5.00016C13.6667 4.07975 12.9208 3.3335 12 3.3335C11.0792 3.3335 10.3333 4.07975 10.3333 5.00016C10.3333 5.921 11.0792 6.66683 12 6.66683Z",
    fill: "#7AA03F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3333 21.2916V8.6833C17.4792 8.3958 17.6125 8.11247 17.7333 7.82913C17.7542 7.77497 17.775 7.72497 17.7958 7.6708L22.6292 5.73747C23.2875 5.47497 24 5.9583 24 6.66663V17.95C24 18.3583 23.75 18.725 23.3708 18.8791L17.3333 21.2916ZM0.62875 8.13747L5.73333 6.0958C5.83333 6.68747 6.0375 7.27497 6.26667 7.82913C6.3875 8.11247 6.52083 8.3958 6.66667 8.6833V19.1583L1.37125 21.2791C0.714583 21.5041 0 21.0583 0 20.35V9.06663C0 8.6583 0.248958 8.25413 0.62875 8.13747ZM16 21.3458L7.9625 19.0583V10.9583C8.85417 12.2625 9.7625 13.4416 10.3417 14.1291C11.1958 15.2333 12.8042 15.2333 13.6583 14.1291C14.2375 13.4416 15.1458 12.2625 16 10.9583V21.3458Z",
    fill: "#7AA03F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_6609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3333,
    fill: "white",
    transform: "translate(0 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.9f46506f8335736fcd567b45fe2b6bdd.svg";
export { ForwardRef as ReactComponent };